import DentalTreatments from './DentalTreatments';
export default DentalTreatments;